<template>
    <el-dialog :visible.sync="visible" :title="提现审核" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="审核状态" prop="verifyStatus">
                <el-select v-model="verifyStatus" placeholder="审核状态">
                    <el-option v-for="item in allVerifyStatus"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
<!--            <el-form-item label="会员ID" prop="memberId">-->
<!--                <el-input v-model="dataForm.memberId" placeholder="会员ID"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="银行名称" prop="bankName">-->
<!--                <el-input v-model="dataForm.bankName" placeholder="银行名称"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="银行开户名" prop="bankAccountName">-->
<!--                <el-input v-model="dataForm.bankAccountName" placeholder="银行开户名"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="银行卡号" prop="bankCardNumber">-->
<!--                <el-input v-model="dataForm.bankCardNumber" placeholder="银行卡号"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="提现金额" prop="withdrawMoney">-->
<!--                <el-input v-model="dataForm.withdrawMoney" placeholder="提现金额"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="服务费比例" prop="serviceFee">-->
<!--                <el-input v-model="dataForm.serviceFee" placeholder="服务费比例%"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="备注" prop="note">-->
<!--                <el-input v-model="dataForm.note" placeholder="备注"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="审核状态(1：待审核；2：已通过；3：已拒绝；10：确认打款)" prop="verifyStatus">-->
<!--                <el-input v-model="dataForm.verifyStatus" placeholder="审核状态(1：待审核；2：已通过；3：已拒绝；10：确认打款)"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="审核时间" prop="checkTime">-->
<!--                <el-input v-model="dataForm.checkTime" placeholder="审核时间"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="操作人ID" prop="serviceId">-->
<!--                <el-input v-model="dataForm.serviceId" placeholder="操作人ID"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="操作人姓名" prop="serviceName">-->
<!--                <el-input v-model="dataForm.serviceName" placeholder="操作人姓名"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="部门ID" prop="deptId">-->
<!--                <el-input v-model="dataForm.deptId" placeholder="部门ID"></el-input>-->
<!--            </el-form-item>-->
<!--            <el-form-item label="更新时间" prop="updateDate">-->
<!--                <el-input v-model="dataForm.updateDate" placeholder="更新时间"></el-input>-->
<!--            </el-form-item>-->
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'

    export default {
        data() {
            return {
                visible: false,
                allVerifyStatus: [{
                    value: 2,
                    label: '通过'
                }, {
                    value: 3,
                    label: '拒绝'
                }],
                verifyStatus: 2,
                dataForm: {
                    id: '',
                    memberId: '',
                    bankName: '',
                    bankAccountName: '',
                    bankCardNumber: '',
                    withdrawMoney: '',
                    serviceFee: '',
                    note: '',
                    verifyStatus: '',
                    checkTime: '',
                    serviceId: '',
                    serviceName: '',
                    creator: '',
                    deptId: '',
                    createDate: '',
                    updateDate: '',
                    cardType:''
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    memberId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    bankName: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    bankAccountName: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    bankCardNumber: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    withdrawMoney: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    serviceFee: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    note: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    // verifyStatus: [
                    //     {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    // ],
                    // checkTime: [
                    //     {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    // ],
                    serviceId: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    serviceName: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    // deptId: [
                    //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
                    // ],
                    // updateDate: [
                    //   { required: true, message: this.$t('validate.required'), trigger: 'blur' }
                    // ]
                }
            }
        },
        methods: {
            init() {
                this.visible = true
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    // if (this.dataForm.id) {
                    //     this.getInfo()
                    // }
                })
            },
            // 获取信息
            getInfo() {
                this.$http.get(`/ums/cashwithdrawal/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.dataForm.verifyStatus = this.verifyStatus
                    this.$http[!this.dataForm.id ? 'post' : 'put']('/ums/cashwithdrawal/', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>
